
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppCard, AppButton, AppDateTimePicker } from '@/components';
import { useMaintenance } from '@/modules/maintenance/maintenance';
import { ROUTE_NAME_MAINTENANCE } from '@/modules/maintenance/router';

export default defineComponent({
    name: ROUTE_NAME_MAINTENANCE,
    components: { AppFormRow, AppCard, AppButton, AppDateTimePicker },
    setup() {
        const { model, v$, fetch, actions } = useMaintenance();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
